import Form from './Form';

export default class ProfileHeaderForm extends Form {
    templateId() {
        return '#profileHeaderFormTemplate';
    }

    data() {
        return '/dashboard/profile/ajax/profileHeader/get';
    }

    onLoad(container) {
        this.setupDropzone('#dropArea1');
    }

    setupDropzone(element) {
        var photoForm = this;
        var myDropzone = $(element).dropzone({
            fallback: function(){
                $('#compatibilityWarning').html( '<div class="alert alert-warning" role="alert"><b>Your browser does not support easy image uploading.</b> To update the image of this user please use IE 10+, Firefox 4+, Chrome 7+ or the Snap21 app on your mobile device.</div>' );
                return false;
            },
            url: "/php/fileGenerators/uploadFiles.php?folder=profileHeaders",
            paramName: "file",
            maxFilesize: 50, // mb (.16 MB = 163 KB)
            createImageThumbnails: true,
            clickable: element+'.dropContainer, '+element+' img',
            previewsContainer: element+' .dropzoneDetails',
            init: function() {
                $(element+' .dropzoneDetails').html('Drop file or tap here to upload.');
            },
            accept: function(file, done) {
                $(element+' .dropzoneDetails').html('Uploading '+file.name);
                done();
            },
            success: function(file, result) {
                if (result.status == "success") {
                    $(element+' .dropzoneDetails').html('Uploaded. Complete form and save to apply.');
                    $(element+' .preview').attr('src', result.photoData);
                    $(element+' .linkInput').val(result.urlToPicture);
                    $(element+'.dropContainer').addClass('success');
                } else {
                    $(element+' .dropzoneDetails').html(result.errorMessage);
                }
            },
            error: function(file, errorMessage) {
                $(element+' .dropzoneDetails').html(errorMessage);
            },
            previewTemplate: '<span></span>',
            resizeWidth: '800',
            resizeQuality: 1,
            transformFile: function (file, done) {
                if ((this.options.resizeWidth || this.options.resizeHeight) && file.type.match(/image.*/)) {
                    return photoForm.resizeImage(this, file, this.options.resizeWidth, this.options.resizeHeight, this.options.resizeMethod, done);
                } else {
                    return done(file);
                }
            },
            thumbnail: function (file) {
                // rotate image based on EXIF orientation data

                // loadImage comes from blueimp-load-image
                window.loadImage.parseMetaData(file, (data) => {
                    if (data.exif) {
                        // In case the EXIF is readable, we display a canvas element
                        // with the rotated image and hide the default thumbnail.
                        window.loadImage(file, (img) => {
                            $('#dropArea1 img').replaceWith(img)
                            $('#dropArea1 canvas').addClass('preview dz-clickable');
                        }, {
                            orientation: data.exif.get('Orientation'),
                        });
                    } else {
                        // In case the EXIF data is unavailable, we just show the default thumbnail.
                        // filepicker.classList.add('js-dropzone--show-thumbmail');
                    }
                });
            }
        });
    }

    //-------------------------------------------------------------
    // Below are methods extracted from dropzone to be overloaded
    // in order to use our own resize method for better quality
    //-------------------------------------------------------------

    createThumbnailFromUrl(dropzone, file, width, height, resizeMethod, fixOrientation, callback, crossOrigin) {
        var _this14 = dropzone;

        // Not using `new Image` here because of a bug in latest Chrome versions.
        // See https://github.com/enyo/dropzone/pull/226
        var img = document.createElement("img");

        if (crossOrigin) {
            img.crossOrigin = crossOrigin;
        }

        img.onload = function () {
            var loadExif = function loadExif(callback) {
                return callback(1);
            };
            if (typeof EXIF !== 'undefined' && EXIF !== null && fixOrientation) {
                loadExif = function loadExif(callback) {
                    return EXIF.getData(img, function () {
                            return callback(EXIF.getTag(this, 'Orientation'));
                            });
                };
            }

            return loadExif(function (orientation) {
                // create our own canvas and draw the full image to it
                // this will be used to copy and downsize from
                var fileCanvas = document.createElement("canvas");
                var fileCtx = fileCanvas.getContext("2d");
                fileCanvas.width = img.width;
                fileCanvas.height = img.height;
                fileCtx.drawImage(img, 0, 0);

                file.width = img.width;
                file.height = img.height;

                var resizeInfo = _this14.options.resize.call(_this14, file, width, height, resizeMethod);

                var canvas = document.createElement("canvas");
                var ctx = canvas.getContext("2d");

                canvas.width = resizeInfo.trgWidth;
                canvas.height = resizeInfo.trgHeight;

                // This is a bugfix for iOS' scaling bug.
                drawImageIOSFix(ctx, img, resizeInfo.srcX != null ? resizeInfo.srcX : 0, resizeInfo.srcY != null ? resizeInfo.srcY : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, resizeInfo.trgX != null ? resizeInfo.trgX : 0, resizeInfo.trgY != null ? resizeInfo.trgY : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);

                // use pica library to resize from fileCanvas to canvas
                const pica = require('pica')();
                pica.resize(fileCanvas, canvas)
                    .then(result => pica.toBlob(result, 'image/jpeg', 0.90))
                    .then(function (blob) {
                        var reader = new window.FileReader();
                        var thumbnail;

                        // convert from blob to data URL
                        reader.readAsDataURL(blob);
                        reader.onloadend = function() {
                            thumbnail = reader.result;
                            if (callback != null) {
                                callback(thumbnail, canvas);
                            }
                        }
                    });
            });
        };

        if (callback != null) {
            img.onerror = callback;
        }

        return img.src = file.dataURL;
    }

    createThumbnail(dropzone, file, width, height, resizeMethod, fixOrientation, callback) {
        var _this13 = dropzone;

        var fileReader = new FileReader();

        var photoForm = this;
        fileReader.onload = function () {

            file.dataURL = fileReader.result;

            // Don't bother creating a thumbnail for SVG images since they're vector
            if (file.type === "image/svg+xml") {
                if (callback != null) {
                    callback(fileReader.result);
                }
                return;
            }

            return photoForm.createThumbnailFromUrl(dropzone, file, width, height, resizeMethod, fixOrientation, callback);
        };

        return fileReader.readAsDataURL(file);
    }

    resizeImage(dropzone, file, width, height, resizeMethod, callback) {
        var _this12 = dropzone;

        return this.createThumbnail(dropzone, file, width, height, resizeMethod, false, function (dataUrl, canvas) {
            if (canvas === null) {
                // The image has not been resized
                return callback(file);
            } else {
                var resizeMimeType = _this12.options.resizeMimeType;

                if (resizeMimeType == null) {
                    resizeMimeType = file.type;
                }

                var resizedDataURL = canvas.toDataURL(resizeMimeType, _this12.options.resizeQuality);
                if (resizeMimeType === 'image/jpeg' || resizeMimeType === 'image/jpg') {
                    // Now add the original EXIF information
                    resizedDataURL = ExifRestore.restore(file.dataURL, resizedDataURL);
                }

                return callback(Dropzone.dataURItoBlob(resizedDataURL));
            }
        });
    }

}
